module.exports = __webpack_public_path__ + "static/img_9852_dpp_optimized-1bf10552523393fd7c341d7588483465.jpg";